module.exports = __webpack_public_path__ + "img/20180815_154807_242.55406537.jpg";